<!-- korisnici.component.html -->
<div class="grid-section">
  <div class="toolbar">
    <dx-button *ngIf="isUserAgroAdmin" icon="plus" text="Dodaj novog" type="default" (onClick)="onAddClick()">
    </dx-button>

    <dx-button *ngIf="isUserAgroAdmin" icon="edit" text="Izmijeni" type="default" [disabled]="!selectedKorisnik"
      (onClick)="onEditClick()">
    </dx-button>

    <dx-button icon="refresh" text="Osvježi" type="default" (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid #korisniciGrid id="korisniciGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
    [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
    [allowColumnReordering]="true" [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 20 }" [pager]="{
        visible: true,
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50],
        showInfo: true,
        showNavigationButtons: true
    }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true"
    [scrolling]="{ mode: 'standard', rowRenderingMode: 'virtual' }" [loadPanel]="{ enabled: true }"
    (onRowClick)="onKorisnikRowClick($event)">

    <dxi-column dataField="username" caption="Ime" [minWidth]="150" [allowFiltering]="true" [allowSearch]="true">
    </dxi-column>

    <dxi-column dataField="firmaNaziv" caption="Firma" [allowFiltering]="true" [allowSearch]="true">
    </dxi-column>

    <dxi-column dataField="aktivan" caption="Aktivan" [minWidth]="80" dataType="boolean" [falseText]="'Ne'"
      [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="user_agro" caption="User Agro" [minWidth]="100" dataType="boolean" [falseText]="'Ne'"
      [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="user_transport" caption="User Transport" [minWidth]="120" dataType="boolean"
      [falseText]="'Ne'" [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="mod_agro" caption="Mod Agro" [minWidth]="100" dataType="boolean" [falseText]="'Ne'"
      [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="mod_transport" caption="Mod Transport" [minWidth]="120" dataType="boolean" [falseText]="'Ne'"
      [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="owner_agro" caption="Owner Agro" [minWidth]="100" dataType="boolean" [falseText]="'Ne'"
      [trueText]="'Da'">
    </dxi-column>

    <dxi-column dataField="owner_transport" caption="Owner Transport" [minWidth]="120" dataType="boolean"
      [falseText]="'Ne'" [trueText]="'Da'">
    </dxi-column>

    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup [width]="500" [height]="600" [showTitle]="true" title="Dodaj Novog Korisnika"
  [(visible)]="isCreatePopupVisible" (onHiding)="onCreatePopupHidden()">

  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="korisnikForm">
      <div class="form-fields">
        <dx-text-box formControlName="username" placeholder="Korisničko ime"
          [isValid]="!korisnikForm.get('username')?.errors" validationMessage="Korisničko ime je obavezno">
        </dx-text-box>

        <dx-text-box #passwordInput formControlName="password" placeholder="Lozinka" [mode]="passwordMode"
          [buttons]="passwordButtons" [isValid]="!korisnikForm.get('password')?.errors"
          validationMessage="Lozinka je obavezna">
        </dx-text-box>

<dx-lookup
  formControlName="firma"
  [dataSource]="firmeData"
  displayExpr="naziv"
  valueExpr="id"
  placeholder="Odaberite firmu..."
  [searchEnabled]="true"
  [isValid]="!korisnikForm.get('firma')?.errors"
  validationMessage="Firma je obavezna">
</dx-lookup>

        <dx-check-box formControlName="aktivan" text="Aktivan" [value]="true">
        </dx-check-box>

        <div class="permissions-section">
          <h4>Robna ponuda Permisije:</h4>
          <dx-check-box formControlName="userAgro" text="Komitent"></dx-check-box>
          <dx-check-box formControlName="modAgro" text="Moderator (zaposleni u Agro Informeru)"></dx-check-box>
          <!-- <dx-check-box formControlName="ownerAgro" text="Owner Agro"></dx-check-box> -->
        </div>

        <!-- <div class="permissions-section">
          <h4>Transport Doo Permisije:</h4>
          <dx-check-box formControlName="userTransport" text="User Transport"></dx-check-box>
          <dx-check-box formControlName="modTransport" text="Mod Transport"></dx-check-box>
          <dx-check-box formControlName="ownerTransport" text="Owner Transport"></dx-check-box>
        </div> -->
      </div>

      <div class="popup-buttons">
        <dx-button *ngIf="isUserAgroAdmin" text="Kreiraj" type="default" (onClick)="createKorisnik()"
          [disabled]="!korisnikForm.valid || loading">
        </dx-button>

        <dx-button text="Otkaži" type="default" (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup [width]="500" [height]="600" [showTitle]="true" title="Izmijeni Korisnika" [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">

  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="korisnikForm">
      <div class="form-fields">
        <dx-text-box formControlName="username" placeholder="Korisničko ime" [readOnly]="true"
          [isValid]="!korisnikForm.get('username')?.errors" validationMessage="Korisničko ime je obavezno">
        </dx-text-box>

        <dx-text-box #passwordInput formControlName="password" placeholder="Lozinka" [mode]="passwordMode"
          [buttons]="passwordButtons" [isValid]="!korisnikForm.get('password')?.errors"
          validationMessage="Lozinka je obavezna">
        </dx-text-box>

<dx-lookup
  formControlName="firma"
  [dataSource]="firmeData"
  displayExpr="naziv"
  valueExpr="id"
  placeholder="Odaberite firmu..."
  [searchEnabled]="true"
  [isValid]="!korisnikForm.get('firma')?.errors"
  validationMessage="Firma je obavezna">
</dx-lookup>

        <dx-check-box formControlName="aktivan" text="Aktivan" [value]="true">
        </dx-check-box>

        <!-- <div class="permissions-section">
          <h4>Robne Permisije:</h4>
          <dx-check-box formControlName="userAgro" text="User Agro"></dx-check-box>
          <dx-check-box formControlName="modAgro" text="Mod Agro"></dx-check-box>
          <dx-check-box formControlName="ownerAgro" text="Owner Agro"></dx-check-box>
        </div>

        <div class="permissions-section">
          <h4>Transport Permisije:</h4>
          <dx-check-box formControlName="userTransport" text="User Transport"></dx-check-box>
          <dx-check-box formControlName="modTransport" text="Mod Transport"></dx-check-box>
          <dx-check-box formControlName="ownerTransport" text="Owner Transport"></dx-check-box>
        </div> -->
      </div>

      <div class="popup-buttons">
        <dx-button *ngIf="isUserAgroAdmin" text="Resetuj mobilni uređaj" type="default"
          (onClick)="updateKorisnikMobileDeviceId()" [disabled]="!korisnikForm.valid || loading">
        </dx-button>

        <dx-button *ngIf="isUserAgroAdmin" text="Ažuriraj" type="default" (onClick)="updateKorisnik()"
          [disabled]="!korisnikForm.valid || loading">
        </dx-button>

        <dx-button text="Otkaži" type="default" (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
  [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>